export default __webpack_public_path__ + "static/media/mail.a6209c01.svg";